<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM LỚP HỌC CHÍNH KHÓA</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <ClassNewForm ref="form" :classData="{}" :major="major" :course="course" />
      <v-card-actions>
        <v-spacer />
        <v-btn depressed color="primary" class="mr-2 mt-n4 mb-2 white--text" @click="save">
          <v-icon color="white" left> mdi-plus </v-icon>Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClassNewForm from '@/components/basic/form/ClassNewForm.vue'
import { mapActions, mapGetters } from 'vuex'
import { Class, Teaching, Subject } from '@/plugins/api'
import { chunk, get } from 'lodash'

export default {
  components: {
    ClassNewForm
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapGetters('class', ['classes'])
  },
  methods: {
    ...mapActions('class', ['createClass']),
    async save() {
      if (!this.$refs.form.validate()) return

      const data = this.$refs.form.getData()
      if (await Class.count({ title: data.title })) {
        this.$alert.error('Tên lớp đã tồn tại')
        return
      }
      let classData = {}
      try {
        this.$loading.active = true
        classData = await this.createClass({
          ...data,
          status: 'running',
          type: 'coreCurriculum'
        })
        const grade = `00${classData.grade.gradeNumber}`.substr(`00${classData.grade.gradeNumber}`.length - 2)
        const subjects = await Subject.fetch({ division: classData.division.id, grade: classData.grade.id })
        const groups = chunk(subjects, 5)
        for (let subSubjects of groups) {
          await Promise.all(
            subSubjects.map(async subject => {
              const sgIndex = `00${subject.subjectGroup && subject.subjectGroup.index}`.substr(
                `00${subject.subjectGroup && subject.subjectGroup.index}`.length - 2
              )
              const tags = grade + classData.title + sgIndex

              return Teaching.create({
                class: classData.id,
                grade: classData.grade.id,
                subject: subject.id,
                subjectGroup: get(subject.subjectGroup, 'id'),
                tags
              })
            })
          )
        }

        this.$alert.addSuccess()
        this.$refs.form.reset()
        this.dialog = false
        this.$emit('done', classData)
      } catch (error) {
        this.$alert.addError(error)
        await Class.remove(get(classData, 'id'))
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    }
  },

  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
